
import React from 'react';
import PricingTable from '@/components/PricingTable';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';

const Pricing = () => {
  const faqItems = [
    {
      question: "What's included in the Basic Course?",
      answer: "The Basic Course includes all foundational materials and worksheets. This is perfect for beginners who want to get started with the core concepts."
    },
    {
      question: "How does the Course + Bonus package work?",
      answer: "The Course + Bonus package includes everything in the Basic Course plus additional bonus materials, AI Development Swipe File and 100 AI Development prompts. This is our most popular option as it provides significantly more value for a small additional investment."
    },
    {
      question: "What will I get with the Premium Offer?",
      answer: "The Premium Offer includes lifetime access to the course and bonus materials, plus premium course materials and priority email support. This is ideal for those who want comprehensive training and resources with no time constraints."
    },
    {
      question: "What makes the Advanced Program worth $497?",
      answer: "The Advanced Program includes everything from previous tiers plus advanced strategies, and a personal implementation plan. This hands-on approach helps ensure your success through personalized guidance and accountability."
    }
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <section className="bg-gradient-to-br from-blue-50 to-purple-100 py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="mb-6 text-4xl font-bold text-gray-900 md:text-5xl">
            Get Started with AI-Powered App Development
          </h1>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="mx-auto max-w-2xl text-xl text-gray-600">
            Unlock your potential and bring your app ideas to life with our expert-guided courses and development services. Choose the perfect plan and start building today!
          </p>
        </div>
      </section>

      <section className="py-16 container mx-auto px-4">
        <PricingTable />
      </section>

      <section className="py-16 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
            <div className="w-16 h-1 bg-orange-500 mx-auto mb-4"></div>
            <p className="max-w-2xl mx-auto text-gray-600">
              Find answers to common questions about our AI app development plans and services
            </p>
          </div>
          
          <div className="mx-auto max-w-3xl">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <Accordion type="single" collapsible className="w-full">
                {faqItems.map((item, index) => (
                  <AccordionItem key={index} value={`item-${index}`} className="border-b border-gray-100 last:border-0">
                    <AccordionTrigger className="px-6 py-4 text-left font-medium hover:text-orange-500 text-gray-800">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent className="px-6 pb-4 text-gray-600">
                      {item.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
            
            <div className="mt-12 text-center">
              <h3 className="text-xl font-semibold mb-4">Still have questions?</h3>
              <p className="text-gray-600 mb-6">
                Can't find the answer you're looking for? Please contact our support team.
              </p>
              <div className="max-w-xs mx-auto">
                <a href="mailto:support@applaunchai.com">
                  <Button className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 px-6 rounded-md transition-colors">
                    Contact Support
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
